export default __webpack_public_path__ + "static/media/lower-arrow.26d46958.svg";